import styled from "styled-components";

const PaymentsWrapper = styled.div`
  .p-accordion .p-accordion-content {
    background-color: #f2f2f2;
    min-height: 300px;
    border-radius: 8px;
    margin-bottom: 1rem;
  }

  .p-accordion .p-accordion-header .p-accordion-header-link {
    border-radius: 0;
    &:focus {
      box-shadow: none;
    }
    .p-accordion-toggle-icon {
      display: none;
    }
  }
  .payment-buttons {
    button {
      border: 1px solid #eef2f5;
      border-radius: 8px;
      outline: none;
      // margin-right: 10px;
      padding: 0.8rem 1.25rem;
      color: #000;

      &:focus {
        box-shadow: none;
      }

      &:hover {
        border: 1px solid #cecece !important;
        color: #fff !important;
        background: ${(props) =>
          props.businessColor ? props.businessColor : "#6b47f5"};
        .p-button-label {
          //filter: brightness(100) ;
        }
      }
      &.active {
        background: ${(props) =>
          props.businessColor ? props.businessColor : "#6b47f5"};
        color: white !important;
        .p-button-label {
          //filter: brightness(100) ;
        }
      }
      &.worldcup_inactive_btn_color {
        color: ${(props) =>
          props.businessColor ? props.businessColor : "#6b47f5"};
      }
    }

    // .payment-buttons-stc {
    //   button {
    //     &:hover {
    //       background: #4f008c !important;
    //     }
    //     &.active {
    //       background: #4f008c;
    //     }
    //   }
    //   &.worldcup_inactive_btn_color {
    //     color: #4f008c;
    //   }
    // }

    .tw-credit-card {
      text-transform: uppercase;
      font-weight: 800;
      font-family: Bliss2;
      color: #333;

      &.active {
        background-color: #6b47f5;
        color: #fff;
      }
    }
  }

  .btn {
    font-size: 1rem;
    height: 40px;
    width: 100%;
    border-radius: 0;
    text-transform: uppercase;
    &.primary {
      color: #fff;
      background: #6b47f5;
    }
    &.secondary {
      color: #fff;
      background: #6b47f5;
    }
    &.secondary-outline {
      color: #6b47f5;
      background: transparent;
      border-color: #6b47f5;
    }
  }

  .left-col {
    h5 {
      color: ${(props) =>
        props.businessColor ? props.businessColor : "#6b47f5"};
    }
  }
  .primary {
    display: flex;
    align-items: center;
    height: 50px;
    justify-content: center;
    color: #ffffff;
    background: #6b47f5;
    border: 1px solid #6b47f5;
    border-radius: 0;
    padding: 8px 15px;
    font-weight: 700;
    height: 43px;
    .p-button-icon {
      margin-right: 10px;
    }
    &:hover {
      border: 1px solid #6b47f5;
    }
    img {
      margin: 0 5px;
    }
    &:focus {
      box-shadow: none;
    }
  }

  .right-col {
    text-align: initial;

    .card-form-title {
      font-family: "Open Sans", sans-serif;
      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: initial;
      color: #4c565c;
    }
  }

  .pw_custom_icon img {
    margin-top: -10px;
  }

  iframe {
    /* This fixes a mobile Safari bug */
    height: 38px !important;
  }

  #payment-form {
    width: 280px;
    margin: 0 auto;
  }

  label {
    display: block;
    height: 10px;
    color: #13395e;
    font-size: 14px;
    font-weight: 500;
    line-height: 10px;
    margin: 8px 0;
  }

  .date-and-code {
    display: flex;
    margin-bottom: 8px;
  }

  .date-and-code > div:nth-child(1) {
    width: 55.715%;
  }

  .date-and-code > div:nth-child(2) {
    width: 45.719%;
  }

  .input-container {
    position: relative;
    display: flex;
    height: 40px;
  }

  .icon-container:last-child {
    right: 0;
  }

  .icon-container.payment-method {
    right: 0;
  }

  .input-container.card-number {
    margin-bottom: 8px;
  }

  .input-container.expiry-date {
    margin-right: 8px;
  }

  .card-number-frame,
  .expiry-date-frame,
  .cvv-frame {
    flex: 1 1 auto;
    padding-left: 10px;
  }

  div + button {
    margin-top: 8px;
  }

  .icon-container {
    position: absolute;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    width: 26px;
    margin: 0 7px;
  }

  .icon-container.payment-method {
    transform: translateY(-50%) rotateY(90deg);
    transition: opacity 0.15s ease-out;
    opacity: 0;
    top: 50%;
  }

  .icon-container.payment-method.show {
    opacity: 1;
    transition: all 0.4s ease-out;
    transform: translateY(-50%) rotateY(0deg);
  }

  .icon-container.payment-method img {
    width: 100%;
  }

  [id$="-error"] {
    display: none;
  }

  .frame {
    opacity: 0;
  }

  .frame--activated {
    opacity: 1;
    border: solid 1px #13395e;
    border-radius: 3px;
    box-shadow: 0 1px 3px 0 rgba(19, 57, 94, 0.2);
  }

  .frame--activated.frame--focus {
    border: solid 1px #13395e;
    box-shadow: 0 2px 5px 0 rgba(19, 57, 94, 0.15);
  }

  .frame--activated.frame--invalid {
    border: solid 1px #d96830;
    box-shadow: 0 2px 5px 0 rgba(217, 104, 48, 0.15);
  }

  .error-message {
    display: block;
    color: #c9501c;
    font-size: 0.9rem;
    margin: 8px 0 0 1px;
    font-weight: 300;
  }

  #pay-button {
    border: none;
    border-radius: 3px;
    color: #fff;
    font-weight: 500;
    height: 40px;
    width: 100%;
    background-color: #13395e;
    box-shadow: 0 1px 3px 0 rgba(19, 57, 94, 0.4);
  }

  .tamara {
    height: 50px;
    align-items: center;
  }
  .tamara-line-height{
    line-height: 1rem;
  }
  #pay-button:active {
    background-color: #0b2a49;
    box-shadow: 0 1px 3px 0 rgba(19, 57, 94, 0.4);
  }

  #pay-button:hover {
    background-color: #15406b;
    box-shadow: 0 2px 5px 0 rgba(19, 57, 94, 0.4);
  }

  #pay-button:disabled {
    background-color: #697887;
    box-shadow: none;
  }

  #pay-button:not(:disabled) {
    cursor: pointer;
  }

  .success-payment-message {
    color: #13395e;
    line-height: 1.4;
  }

  .token {
    color: #b35e14;
    font-size: 0.9rem;
    font-family: monospace;
  }

  /**
    IE11-targeted optimisations
    */
  _:-ms-fullscreen,
  :root .icon-container {
    display: block;
  }

  _:-ms-fullscreen,
  :root .icon-container img {
    top: 50%;
    -ms-transform: translateY(-50%);
    position: absolute;
  }

  _:-ms-fullscreen,
  #icon-card-number,
  _:-ms-fullscreen,
  #icon-expiry-date,
  _:-ms-fullscreen,
  #icon-cvv {
    left: 7px;
  }

  #checkout-frames-card-number::-ms-clear {
    display: none;
  }
  @media screen and (max-width: 768px) {
    .payment-buttons {
      display: none;
    }
    .pg_mobile-heading {
      font-family: Bliss2;
      font-size: 17px;
      font-weight: 800;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: initial;
      color: #595e66;
    }
    .p-accordion {
      .p-accordion-tab-active {
        .p-accordion-header {
          .p-accordion-header-link {
            background-color: #6b47f5 !important;
            color: #fff !important;
            .p-accordion-header-text {
              //filter: brightness(100) ;
            }
          }
        }
      }
      .p-accordion-header {
        &.tw-credit-card {
          text-transform: uppercase;
          color: #4c565c;
        }
        .p-accordion-header-link {
          border-radius: 10px;
          background-color: #fff !important;
        }
        &.p-highlight {
          .p-accordion-header-link {
            background-color: #fff;
          }
        }
      }
      .p-accordion-content {
        background-color: #fbfbfb !important;
        min-height: auto;
      }
    }
  }
  @media screen and (min-width: 769px) {
    .p-accordion-header-link {
      display: none;
    }
  }

  .tamara-pay {
    border-radius: 0.75rem;
    width: 100%;
    padding: 1rem;
    border-radius: 10px;
    border-color: rgb(229, 229, 229);
    border-style: solid;
    border-width: 1px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 4rem;
  }

  /* CSS */
  .apple-pay-button {
    display: block;
    -webkit-appearance: -apple-pay-button;
    -apple-pay-button-type: buy; /* Use any supported button type. */
    height: 50px;
    cursor: pointer;
  }
  .apple-pay-button-black {
    -apple-pay-button-style: black;
  }
  .apple-pay-button-white {
    -apple-pay-button-style: white;
  }
  .apple-pay-button-white-with-line {
    -apple-pay-button-style: white-outline;
  }

  @media only screen and (max-width: 575.99px) {
    .tamara-pay {
    }
  }
`;

export default PaymentsWrapper;
